import { LinkButton } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import { maxWidth, mq } from '@sleepstation/style-api-helpers'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const READ_PDF_BUTTON_LABEL = `Read PDF`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })`
  > * {
    width: 100%;

    ${mq(`smallUp`)} {
      ${maxWidth(12)}
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PDFContent = ({ url }) => (
  <Layout>
    <ThemeProvider theme={defaultAltTheme}>
      <LinkButton href={url} icon="pdf" kind="secondary" iconIsLast>
        {READ_PDF_BUTTON_LABEL}
      </LinkButton>
    </ThemeProvider>
  </Layout>
)

PDFContent.propTypes = { url: PropTypes.string.isRequired }

PDFContent.defaultProps = {}

export default PDFContent
